import { useCallback, useEffect, useState } from "react";

const getMountDefaultCols = (uniqueIdentifier, defaultCols) => {
    try{
        const colsOnStorage = localStorage.getItem(uniqueIdentifier);

        if (!colsOnStorage) {
            return defaultCols;
        }
        else {
            return colsOnStorage.split(',');
        }
    }
    catch(e) {
        console.warn(e);
    }

    return defaultCols;
}

const useTableColumnCustomizer = ({
    defaultSelectedCols,
    uniqueIdentifier,
}) => {
    const [selectedColumns, setSelectedColumns] = useState(
        () => {
            return getMountDefaultCols(
                uniqueIdentifier, 
                defaultSelectedCols
            )
        }
    );

    const onColumnsChange = useCallback((col) => {
        if (selectedColumns.includes(col.dataField)) {
            setSelectedColumns((currentState) => {
                const newState = currentState.filter((c) => c !== col.dataField)

                setTimeout(() => {
                    localStorage.setItem(uniqueIdentifier, newState);
                }, 250);

                return newState;
            });
        } else {
            setSelectedColumns((currentState) => {
                const newState = [...currentState, col.dataField];

                setTimeout(() => {
                    localStorage.setItem(uniqueIdentifier, newState);
                }, 250);

                return newState;
            });
        }
    }, [ selectedColumns ]);

    useEffect(() => {
        const colsOnStorage = localStorage.getItem(uniqueIdentifier);

        if (!colsOnStorage) {
            localStorage.setItem(uniqueIdentifier, defaultSelectedCols);
        }
    }, []);

    return {
        onColumnsChange,
        selectedColumns
    }
}

export default useTableColumnCustomizer;